// JS file for IssueGuidelineItem
